import React, {useLayoutEffect, useRef, useState} from 'react';
import styles from './styles';
import {TextInput, Button, ModalContainer} from '@xpertdox_js/xdcomponents';
import EditNct from '../../UserManagement/editNct';
import EditApps from '../../UserManagement/editApps';
import UserLogs from '../../UserManagement/userLogs';
import axios from 'axios';
import axiosConfig from '../../../config/axios.config';
import { UserContext } from '../../../Context/UserContext';
import { trackError } from '../../../utils/activityTracker'

const validators = {
  name: /^[a-zA-Z ]+$/,
  phoneNumber: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
}

const ContactEdit = props => {
  const updateHandler = (value) => {
    props.updateHandler(value, props.id, props.type)
    console.log('props', value, props.id, props.type);
  };

  return(
    <TextInput
      styles={styles.inputStyles}
      label={props.label}
      value={props.data[props.type]}
      setter={updateHandler}
      type={props.type}
    />
  )
}

const UserManagementDropDown = props => {
  const [formState, setFormState] = useState(props.data);
  const { user, userAction } = React.useContext(UserContext);
  const [showModal, setShowModal] = React.useState(false)
  const handleSave = async () => {
    let valid = await(validateForm())
    if (valid) {
      // console.log('formState', formState);
      let userObj = {
        division: formState.division,
        affiliation: formState.affiliation,
        userTitle: formState.userTitle,
        phoneNumber: formState.phoneNumber,
        userId: formState._id,
        name: formState.name
      }
      // removed 'axiosConfig.auth' as token is updated on login
      axios.post(`${axiosConfig.ssoApi}/backend/rt/user/update`, userObj)
      .then(response => {
        props.userDetails();
        props.dataRefresh();
      }).catch(error => {
        console.log('error', error);
        trackError({ error: error, history: props.history })
        if (error.response.status === 403) {
          userAction({type: 'logout'})
        }
      });
    }
  }

  const updateHandler = (value, type) => {
    // console.log(value, type)
    let update = formState ? {...formState}: {};
    update[type] = value;
    setFormState(update)
  }

  const validateForm = () => {
    return new Promise((resolve,reject) => {
      let returnValue ;
      let validatedForm = {...formState}
      console.log('validate form', validatedForm, validators.name.test(validatedForm.name), validators.phoneNumber.test(validatedForm.phoneNumber));

      if (validatedForm.name === ''
          || !validators.name.test(validatedForm.name)
          || !validators.phoneNumber.test(validatedForm.phoneNumber)
      ) {
            returnValue = false
        if (validatedForm.name === '' && validatedForm.phoneNumber === '') {
          returnValue = true
        }
      } else {
        returnValue = true
      }
      setFormState(validatedForm)
      resolve(returnValue)
    })
  }


  const setWidth = formState && formState.email.length === 0 ? styles.field : {...styles.field, width: '15%'}

  const User = <div style={{...styles.fieldWrap, paddingBottom: '10px'}}>
        <div style={setWidth}>
          <ContactEdit
            label={'User Name'}
            id={'name'}
            data={formState}
            type='name'
            updateHandler={updateHandler}
          />
        </div>
        <div style={setWidth}>
          <ContactEdit
            label={'User Telephone'}
            id={'phoneNumber'}
            data={formState}
            type='phoneNumber'
            updateHandler={updateHandler}
          />
        </div>
        <div style={setWidth}>
          <ContactEdit
            label={'User Affiliation'}
            id={'affiliation'}
            data={formState}
            type='affiliation'
            updateHandler={updateHandler}
          />
        </div>
        <div style={setWidth}>
          <ContactEdit
            label={'User Division'}
            id={'division'}
            data={formState}
            type='division'
            updateHandler={updateHandler}
          />
        </div>
      </div>

  const elemRef = useRef();
  useLayoutEffect(() => {
    if (elemRef.current) {
      props.measureCallback(elemRef.current);
    }
  }, [formState])
  // console.log('userMa props', props);
  return(
    <div style={styles.container} ref={elemRef}>
      {User}
      <div style={{
        margin: '0px 1px 12px 1px',
      }}>
        {formState && Object.keys(formState).length > 0 ? <Button
          onClick={handleSave}
          styles={styles.save}
          hoverStyles={styles.saveHov}
          focusStyles={styles.saveHov}
        > Save Changes
        </Button> : ''}
      </div>
      {
        props.data.role === 'Study Team' && <div>
          <div style={styles.separator} />
          <p style={styles.heading}>Add or remove trials the user has access to</p>
          <EditNct {...props} data={formState} />

        </div>
      }
      <div style={styles.separator} />
      <EditApps {...props} data={formState} adminUser={user} />
      <div style={styles.separator} />
      <Button
        onClick={() => setShowModal(true)}
        styles={styles.logs}
      >View User Logs</Button>
      {showModal && <ModalContainer
        open={showModal}
        showOverlay={showModal}
        close={() => setShowModal(false)}
        width={document.body.clientWidth > 1000 ? document.body.clientWidth * .7 : document.body.clientWidth * .9}
        height={window.innerHeight > 800 ? window.innerHeight * .3 : window.innerHeight * .7}
        callback={!showModal ? () => setShowModal(false) : null}
      >
        <UserLogs
          user={user}
        />
      </ModalContainer>}
    </div>
  )
}

export default UserManagementDropDown;
